import './optionalSection.css'

import React, { FC, ReactNode } from 'react'

const RawOptionalSection: FC<{ visible: boolean; children: ReactNode }> = ({
  visible,
  children,
}) => {
  return visible ? <div data-visible-section='true'>{children}</div> : null
}

export const OptionalSection = React.memo(RawOptionalSection)
